export const API_PATH = '/api/v1';
export const APPLICATION_FORM_NAME = 'KaspayForm';

export const ROUTE_FREEZE_DETAIL = '/freeze';

export const ROUTE_ACCOUNT = '/account';
export const ROUTE_ACCOUNT_EMAIL_UNVERIFIED = ROUTE_ACCOUNT + '/email/unverified';
export const ROUTE_ACCOUNT_EMAIL_UPDATE = ROUTE_ACCOUNT + '/email/update';
export const ROUTE_ACCOUNT_GET_STARTED = ROUTE_ACCOUNT + '/get-started';
export const ROUTE_ACCOUNT_PASSWORD_UPDATE = ROUTE_ACCOUNT + '/password/update';
export const ROUTE_ACCOUNT_PHONE_DETAIL = ROUTE_ACCOUNT + '/phone';
export const ROUTE_ACCOUNT_PHONE_SET = ROUTE_ACCOUNT + '/phone/set';
export const ROUTE_ACCOUNT_PHONE_SET_OTP = ROUTE_ACCOUNT + '/phone/set/otp';
export const ROUTE_ACCOUNT_PROFILE = ROUTE_ACCOUNT + '/profile';
export const ROUTE_ACCOUNT_PROFILE_UPDATE = ROUTE_ACCOUNT + '/profile/update';
export const ROUTE_ACCOUNT_STORE_REGISTER = ROUTE_ACCOUNT + '/store/register';
export const ROUTE_ACCOUNT_STORE_UPDATE = ROUTE_ACCOUNT + '/store/update';

export const ROUTE_ACCOUNT_KYC = ROUTE_ACCOUNT + '/kyc';
export const ROUTE_ACCOUNT_KYC_FINISH = ROUTE_ACCOUNT_KYC + '/finish';
export const ROUTE_ACCOUNT_KYC_VERIFICATION_SUCCESS = ROUTE_ACCOUNT_KYC + '/verification-success';
export const ROUTE_ACCOUNT_KYC_OVERVIEW = ROUTE_ACCOUNT_KYC + '/overview';
export const ROUTE_ACCOUNT_KYC_REGISTER = ROUTE_ACCOUNT_KYC + '/register';
export const ROUTE_ACCOUNT_KYC_UPLOAD_DOCUMENT = ROUTE_ACCOUNT_KYC + '/upload';
export const ROUTE_ACCOUNT_KYC_WAITING = ROUTE_ACCOUNT_KYC + '/waiting';

export const ROUTE_CHECKOUT = '/checkout';
export const ROUTE_CHECKOUT_ERROR = ROUTE_CHECKOUT + '/error';
export const ROUTE_CHECKOUT_PREVIEW = ROUTE_CHECKOUT + '/:id';

export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_FORGOT_PASSWORD_OTP = '/forgot-password/otp';

export const ROUTE_INVOICE = '/invoice';
export const ROUTE_INVOICE_DETAIL = '/invoice/:id';
export const ROUTE_INVOICE_EDIT = ROUTE_INVOICE_DETAIL + '/edit';
export const ROUTE_INVOICE_ERROR = '/invoice/error';
export const ROUTE_INVOICE_PAGE = '/invoice/list';
export const ROUTE_INVOICE_PAGE_ALL = ROUTE_INVOICE_PAGE + '/all';
export const ROUTE_INVOICE_PAGE_FILTER = ROUTE_INVOICE_PAGE + '/:filter';
export const ROUTE_INVOICE_NEW = '/invoice/new';
export const ROUTE_INVOICE_ONBOARDING = '/invoice/onboarding';

export const ROUTE_LOGIN = '/login';

export const ROUTE_REGISTER = '/register';
export const ROUTE_REGISTER_OTP = '/register/otp';

export const ROUTE_STATIC = '/static';
export const ROUTE_STATIC_CONTACT_US = ROUTE_STATIC + '/contact-us';
export const ROUTE_STATIC_FAQ = ROUTE_STATIC + '/faq';
export const ROUTE_STATIC_TERM = ROUTE_STATIC + '/term';

export const ROUTE_VERIFICATION = '/verification';
export const ROUTE_VERIFICATION_FORGOT_PASSWORD_EMAIL = ROUTE_VERIFICATION + '/forgot-password/email';
export const ROUTE_VERIFICATION_EMAIL_ADDRESS = ROUTE_VERIFICATION + ROUTE_ACCOUNT + '/email';

export const ROUTE_WALLET = '/wallet';
export const ROUTE_WALLET_DASHBOARD = ROUTE_WALLET + '/dashboard';
export const ROUTE_WALLET_TOPUP = ROUTE_WALLET + '/topup';
export const ROUTE_WALLET_TOPUP_ERROR = ROUTE_WALLET_TOPUP + '/error';

export const ROUTE_WALLET_REDEEM = ROUTE_WALLET + '/redeem';
export const ROUTE_WALLET_REDEEM_ACCOUNT_HISTORY = ROUTE_WALLET_REDEEM + ROUTE_ACCOUNT + '/history';
export const ROUTE_WALLET_REDEEM_ACCOUNT_ADD = ROUTE_WALLET_REDEEM + ROUTE_ACCOUNT + '/add';
export const ROUTE_WALLET_REDEEM_AMOUNT = ROUTE_WALLET_REDEEM + '/amount';
export const ROUTE_WALLET_REDEEM_OTP = ROUTE_WALLET_REDEEM + '/otp';
export const ROUTE_WALLET_REDEEM_FINISH = ROUTE_WALLET_REDEEM + '/finish';

export const ROUTE_WALLET_TRANSFER = ROUTE_WALLET + '/transfer';
export const ROUTE_WALLET_TRANSFER_PHONE = ROUTE_WALLET_TRANSFER + '/phone';
export const ROUTE_WALLET_TRANSFER_PHONE_WITH_PARAM = ROUTE_WALLET_TRANSFER + '/phone/:phone';
export const ROUTE_WALLET_TRANSFER_AMOUNT = ROUTE_WALLET_TRANSFER + '/amount';
export const ROUTE_WALLET_TRANSFER_OTP = ROUTE_WALLET_TRANSFER + '/otp';
export const ROUTE_WALLET_TRANSFER_FINISH = ROUTE_WALLET_TRANSFER + '/finish';
export const ROUTE_WALLET_TRANSFER_QR_CODE = ROUTE_WALLET_TRANSFER + '/qr-code';

export const VERIFICATION_FORGOT_PASSWORD_EMAIL_PATH = ROUTE_VERIFICATION_FORGOT_PASSWORD_EMAIL;
export const VERIFICATION_EMAIL_ADDRESS_PATH = ROUTE_VERIFICATION_EMAIL_ADDRESS + '?verified=true';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/app.ts